import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_DETAILS, AUTH_TOKEN, MENU_ITEMS } from 'constants/AuthConstant';
import { useDispatch } from 'react-redux';
import masterService from 'services/MasterService';



export const initialState = {
    loading: false,
    message: '',
    list: null,
    sublist: null,
    subloading: false
}

export const leadTypeListAll = createAsyncThunk('/leadtype/list', async (data, { rejectWithValue }) => {

    try {
        const response = await masterService.getLeadtype(data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const leadTypeSubListAll = createAsyncThunk('/leadtype/subList', async (data, { rejectWithValue }) => {

    try {
        const response = await masterService.getLeadtype(data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})




export const leadTypeSlice = createSlice({
    name: 'leadType',
    initialState,
    reducers: {

        leadTypeList: (state, action) => {
            state.loading = true
            state.list = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(leadTypeListAll.pending, (state) => {

                state.loading = false
            })
            .addCase(leadTypeListAll.fulfilled, (state, action) => {
                state.loading = true
                state.list = action.payload
            })
            .addCase(leadTypeSubListAll.pending, (state) => {

                state.subloading = false
            })
            .addCase(leadTypeSubListAll.fulfilled, (state, action) => {
                state.subloading = true
                state.sublist = action.payload
            })
    },
})

export const {
    leadTypeList


} = leadTypeSlice.actions

export default leadTypeSlice.reducer